import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = [
  "20 años de experiencia",
  "De confianza",
  "Profesionalidad",
  "Solución integral",
  "Puntualidad",
  "Diagnóstico certero",
];

export const EditorialMarquee = () => {
  return (
    <div data-testid="marquee-section" className="bg-[#EBF6E4] border-y border-[#5AB82D]/15 py-5 overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif-display text-2xl md:text-3xl italic text-[#2E5A1B] px-8 md:px-16">
              {item}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#5AB82D]" />
          </div>
        ))}
      </Marquee>
    </div>
  );
};
